(function(){
  'use strict';
  if(window.location.pathname !== '/policies/terms-of-service') return;

  function fix(){
    var b = document.body; if(!b) return;
    var h = b.innerHTML;

    // 対象プレースホルダーが1つでもあれば処理
    var targets = [
      '[LINK TO REFUND POLICY]',
      '[LINK TO PRIVACY POLICY]',
      '[INSERT TRADING NAME]',
      '[INSERT BUSINESS ADDRESS]',
      '[INSERT BUSINESS PHONE NUMBER]',
      '[INSERT BUSINESS REGISTRATION NUMBER]',
      '[INSERT VAT NUMBER]'
    ];
    var needsFix = false;
    for(var i=0; i<targets.length; i++){
      if(h.indexOf(targets[i]) !== -1){ needsFix = true; break; }
    }
    if(!needsFix) return;

    // 置換ルール
    var reps = [
      // リンク系（コロン+スペース付きのパターンも対応）
      ['our Refund Policy: [LINK TO REFUND POLICY]',
       'our <a href="/policies/refund-policy">Refund Policy</a>'],
      ['our Refund Policy:[LINK TO REFUND POLICY]',
       'our <a href="/policies/refund-policy">Refund Policy</a>'],
      ['review our Refund Policy: [LINK TO REFUND POLICY]',
       'review our <a href="/policies/refund-policy">Refund Policy</a>'],
      ['[LINK TO REFUND POLICY]',
       '<a href="/policies/refund-policy">Refund Policy</a>'],
      ['viewed here: [LINK TO PRIVACY POLICY]',
       'viewed here: <a href="/policies/privacy-policy">Privacy Policy</a>'],
      ['[LINK TO PRIVACY POLICY]',
       '<a href="/policies/privacy-policy">Privacy Policy</a>'],
      // Section 20 個人情報
      ['[INSERT TRADING NAME]',   'ZEN PHARMACY JAPAN'],
      ['[INSERT BUSINESS ADDRESS]','10822-1 Hakamano, Higashikawanobori-cho, Takeo-shi, Saga 843-0234, Japan'],
      ['[INSERT BUSINESS PHONE NUMBER]', '+81-952-97-7847'],
      ['[INSERT BUSINESS REGISTRATION NUMBER]', 'A No.240007 (issued by the Governor of Saga Prefecture, Japan)'],
      ['[INSERT VAT NUMBER]', 'International export sales are zero-rated (Consumption Tax Act, Article 7). No VAT applicable.']
    ];

    var changed = false;
    for(var j=0; j<reps.length; j++){
      if(h.indexOf(reps[j][0]) !== -1){
        h = h.split(reps[j][0]).join(reps[j][1]);
        changed = true;
      }
    }
    if(changed){ b.innerHTML = h; console.log('[ZEN] ToS: all placeholders fixed.'); }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
